<template>
	<v-col class="ma-0 pa-5" cols="12" align="center">
		<v-col class="ma-0 pa-0 mt-15" cols="12" id="group_box">
			<v-col class="ma-0 pa-2" cols="12" id="group_box_title">
				{{tsg('selectSplitScreenLayout')}}
        <v-col id="close_btn" class="ma-0 pa-0" cols="auto"
          v-if="splitListCount > 0">
          <v-btn width="2rem" height="2rem" class="ma-0 pa-0"
                 id="back_clean_btn" elevation="0" @click="clickClose">
            <img src="@/assets/images/popup_close.png" id="btn_img">
          </v-btn>
        </v-col>
			</v-col>
			<v-col class="ma-0 pt-6 pb-6 pl-15 pr-15" cols="12">
				<v-row class="ma-0 pa-0 pt-9 pb-9" align="center">
					<v-col class="ma-0 pa-0" cols="4">
						<v-img max-height="6rem" max-width="8rem" class="ma-0 pa-0 mb-4"
							src="@/assets/images/4view.png"></v-img>
						<v-btn width="auto" height="2rem" class="ma-0 pa-0 pl-2 pr-2" 
							id="blue_btn" elevation="0" @click="selectCameraCount(4)">
							{{'4' + tsg('createdLayoutWithCameras')}}
						</v-btn>
					</v-col>
					<v-col class="ma-0 pa-0" cols="4">
						<v-img max-height="6rem" max-width="8rem" class="ma-0 pa-0 mb-4"
							src="@/assets/images/9view.png"></v-img>
						<v-btn width="auto" height="2rem" class="ma-0 pa-0 pl-2 pr-2" 
							id="blue_btn" elevation="0" @click="selectCameraCount(9)">
							{{'9' + tsg('createdLayoutWithCameras')}}
						</v-btn>
					</v-col>
					<v-col class="ma-0 pa-0" cols="4">
						<v-img max-height="6rem" max-width="8rem" class="ma-0 pa-0 mb-4"
							src="@/assets/images/16view.png"></v-img>
						<v-btn width="auto" height="2rem" class="ma-0 pa-0 pl-2 pr-2" 
							id="blue_btn" elevation="0" @click="selectCameraCount(16)">
							{{'16' + tsg('createdLayoutWithCameras')}}
						</v-btn>
					</v-col>
				</v-row>
			</v-col>
		</v-col>
	</v-col>
</template>

<script>
import mixin from '@/mixin';
export default {
  props: {
    splitListCount: { type: Number, default: 0 }
  },
	components: {
		
	},
	mixins: [mixin.common],
	data: () => ({
		selectedCameraCount: 4,
	}),
	methods: {
		tsg(t) {
      return this.$t("lang.group." + t);
    },
		selectCameraCount(count) {
			this.selectedCameraCount = count;
			this.$emit('selectedCameraCount', count);
		},
    clickClose() {
      this.$emit('selectCancel', true);
    }
	}
}
</script>

<style lang="scss" scoped>
#group_box {
	background-color: #171921;
	border: 1px solid #6A6A6A;
	color: white;
	border-radius: 5px;
	max-width: 700px;
}
#group_box_title {
	border-bottom: 1px solid #6A6A6A;
  position: relative;
}
#close_btn {
  position: absolute;
  top: 5px;
  right: 15px;
}
</style>